import { useEffect, useState } from 'react';
import { supabase } from '../lib/supabase';
import type { MotivoReprovacao } from '../lib/motivosReprovacao';

// Lista de motivos de reprovação da análise cadastral (#6428), com os
// inativos inclusos: análise antiga pode usar motivo que saiu da escolha.
//
// Uma busca por sessão — a lista é pequena e muda raramente. Falha não fica
// guardada: a próxima tela que pedir tenta de novo.
let emCache: Promise<MotivoReprovacao[]> | null = null;

async function buscarMotivos(): Promise<MotivoReprovacao[]> {
    const { data, error } = await supabase
        .from('motivos_reprovacao_analise')
        .select('codigo, rotulo, descricao, ordem, exige_descricao, ativo')
        .order('ordem');
    if (error) throw error;
    return (data ?? []) as MotivoReprovacao[];
}

/**
 * `motivos === null` = carregando. `erro` = não carregou (tabela ainda não
 * criada, rede): a lista fica vazia e quem usa não deve travar a reprovação.
 */
export function useMotivosReprovacao() {
    const [motivos, setMotivos] = useState<MotivoReprovacao[] | null>(null);
    const [erro, setErro] = useState(false);

    useEffect(() => {
        let vivo = true;
        if (!emCache) emCache = buscarMotivos();
        emCache
            .then(lista => { if (vivo) setMotivos(lista); })
            .catch(err => {
                console.warn('Falha ao carregar motivos_reprovacao_analise', err);
                emCache = null;
                if (vivo) { setMotivos([]); setErro(true); }
            });
        return () => { vivo = false; };
    }, []);

    return { motivos, erro };
}
